import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { ButtonV2 } from 'builder/components/Button'

export type PropTypes = {
  isDisabled?: boolean
}
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: ${Spacing['2XS']};
  padding: ${Spacing.XS};
  background-color: ${Colors.Neutral10};

  ${Media.Phone`
     flex-direction: column;
     padding: unset;
  `}
`

export const HeaderContainer = styled.header<{ width?: number }>`
  width: ${({ width }) => `${width}px`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0px 40px 0px;
  height: max-content;
  margin: 0 auto;

  ${Media.Tablet`
    padding: 24px 16px;
  `}

  ${Media.Phone`
     width: 100%;
  `}
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  border-radius: 20px;
  background-color: ${Colors.Blue20};
  color: ${Colors.Blue50};
  padding: 4px 16px 4px 8px;
  ${FontWeights.DemiBold};
  ${Typography.ButtonS};
  cursor: pointer;
  &:hover {
    background-color: ${Colors.Blue30};
    color: ${Colors.Blue60};
  }
  transition: background-color 0.3s ease;
`

export const EditButton = styled(ButtonV2)`
  ${Media.Phone`
    position: absolute;
    bottom: 24px;
    left: 16px;
    right: 16px;
    z-index: 2;
  `}
`

export const IconContainer = styled.div`
  display: flex;
`

export const BackIcon = styled(Icon24.Chevron)`
  width: 20px;
  height: 20px;
  color: ${Colors.Blue50};
  transform: rotate(180deg);
`

export const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 125px;
  bottom: 4px;
  left: 0;
  right: 0;

  ${Media.Phone`
    top: 90px;
    left: 0;
    right: 0;
  `}

  ${Media.Desktop`
    left: 74px;
  right: 74px;
  `}
`

export const Pagination = styled.div`
  position: absolute;
  z-index: 3;
  left: 50%;
  bottom: 80px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 6px;
  background-color: ${Colors.Neutral100};
  border-radius: 18px;
  user-select: none;
  transition: opacity 0.2s;
  transition-delay: 0.2s;
  opacity: 1;
  pointer-events: auto;
`

export const PaginationButton = styled.div<PropTypes>(props => {
  const { isDisabled } = props

  return css`
    border-radius: 50%;
    color: ${Colors.White};
    opacity: ${isDisabled ? 0.3 : 1};
    pointer-events: ${isDisabled ? 'none' : 'auto'};
    cursor: pointer;

    &:hover {
      background-color: ${Colors.Neutral80};
    }

    & svg {
      display: block;
    }
  `
})

export const PaginationPrev = styled(PaginationButton)<PropTypes>`
  transform: rotate(180deg);
`

export const PaginationNext = styled(PaginationButton)<PropTypes>``

export const PaginationCounter = styled.div`
  flex-grow: 1;
  text-align: center;
  min-width: 30px;
  margin: 0 4px;
  color: ${Colors.White};
  ${Typography.Caption};
  font-variant-numeric: tabular-nums;
`

const Scroll = styled.div`
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Colors.Neutral20};
    border-radius: 6px;

    &:hover {
      background-color: ${Colors.Neutral30};
    }
  }
`

export const ContentInner = styled(Scroll)`
  padding: 0 12px;

  ${Media.Phone`
    padding: unset;
  `}
`

export const PreviewBox = styled.div`
  margin: 0 auto 12px;
  transition: transform 0.4s ease, opacity 0.4s ease;

  ${Media.Phone`
    margin: unset;
  `}
`

export const PreviewWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`

export const PreviewImage = styled.img`
  width: 100%;
  max-width: 900px;
  height: auto;
  flex-shrink: 0;
  margin: 0 auto;
`
